import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { AddressPublic, AddressType, LocationPublic, LocationQuestionPublic, LocCreationMode } from '../../../../globalTypes/account.types';
import { FormsModule } from '@angular/forms';
import { MatSelectModule } from '@angular/material/select';
import { attachPhysicalAndBillingAddress, AttachPhysicalAndBillingAddressVariables, attachShippingAddress, AttachShippingAddressVariables, createLocation, CreateLocationVariables, getGooglePlaceIds, getLocationQuestionsPublic, GetLocationQuestionsPublicData, imageUpload, ImageUploadVariables, initiateAddress, InitiateAddressVariables, updateLocation, UpdateLocationVariables, upsertLocationAnswer, UpsertLocationAnswerVariables } from '@dataconnect/account';
import { sortByKey } from '../../helper/general';
import { QuestionAnswerPairsPublic } from '../../../../globalTypes/base.types';
import { ButtonComponent } from "../layout/element/button.component";
import { AccountService } from '../../services/account.service';
import { AuthService } from '../../services/auth.service';
import { UploadImageComponent } from "../image/upload-image.component";
import { Store } from '@ngrx/store';
import { subProp } from '../../store/store';
import { lastValueFrom, take } from 'rxjs';
import { authUserFeature } from '../../store/authUser.store';
import { AuthUser } from '../../../../globalTypes/auth.types';
import { NameTagComponent } from "../layout/element/name.tag.component";
import { ImageUploadPublic, TransferNewUploadedImagesVariables } from '../../../../globalTypes/image.types';
import { Logger } from '../../helper/logger';
import { AddressAutocompleteComponent, AddressAutocompleteReturn } from "./address-autocomplete.component";
import { uiErrorCatcher } from '../../helper/error.handling';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ShippingService } from '../../services/shipping.service';
import { v4 as uuidV4} from 'uuid';
import { UploadService } from '../../services/upload.service';
import { httpsCallable, HttpsCallableResult } from 'firebase/functions';
import { Functions } from '@angular/fire/functions';
import { User } from '../../../../globalTypes/user.types';
import { MatIcon } from "@angular/material/icon";
import { JsonPipe } from '@angular/common';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmDeleteDialogComponent, ConfirmDeleteDialogData } from '../../helper/confirm.delete.dialog';
import { LimiterDirective } from '../../directive/limiter';
import { LOCATION_LABEL } from '../../../../globalTypes/configs';
import { AddressData, AddressDialog } from '../../pages/account/address.dialog';
const log = new Logger("ManageLocationsFormComponent");

@Component({
  selector: 'msh-manage-locations-form',
  imports: [FormsModule, MatSelectModule, ButtonComponent, UploadImageComponent, NameTagComponent, AddressAutocompleteComponent, MatIcon, LimiterDirective],
  template: `
  @if(!hideForm){
    @if(locations.length > 0){
      <div class="mb-3">
        Current Storehouse: 
        @if(cta === 'Update' && currentLocation){
          <input
            type="text"
            placeholder="Location Name"
            [(ngModel)]="newLocation.name"
            name="newLocation.name"
            [limiter]="250"
            required
          />
          <div class="flex items-center justify-between">
            <div class="mt-4 text-xs">
              <div class="font-bold capitalize text-base ">Physical Address</div>
              @if(newLocation && newLocation.physicalAddress; as address){
                <div class="capitalize">{{LOCATION_LABEL}} @if(address.attn) { - {{address.attn}}} </div>
                <div>{{address.streetNumber}} {{address.address}}</div>
                <div>{{address.city}}, {{address.state}} {{address.postcode}}</div>
              }
            </div>
            <mat-icon (click)="onEditLocation( 'physical', newLocation.physicalAddress)" class="cursor-pointer">edit</mat-icon>
          </div>
          <div class="flex items-center justify-between">
            <div class="mt-4 text-xs">
              <div class="font-bold capitalize text-base ">Shipping Address</div>
              @if(newLocation && newLocation.shippingAddress; as address){
                <div class="capitalize">{{LOCATION_LABEL}} @if(address.attn) { - {{address.attn}}} </div>
                <div>{{address.streetNumber}} {{address.address}}</div>
                <div>{{address.city}}, {{address.state}} {{address.postcode}}</div>
              }
            </div>
            <mat-icon (click)="onEditLocation( 'shipping', newLocation.shippingAddress)" class="cursor-pointer">edit</mat-icon>
          </div>
        }@else {
          <msh-name-tag class="block mt-3 mb-7" [label]="currentLocation?.name" [url]="currentLocation?.profileImage?.url"></msh-name-tag>
          
        }
      </div>
      @if(cta === 'Update'){
        @if(locations.length > 1){
          <mat-select (selectionChange)="onSelectLocationChange()" class="w-full my-7 block px-3 py-2 rounded border border-navy/15" [(ngModel)]="selectedLoc">
            @for(loc of locations; track loc.id){
              <mat-option [value]="loc">
                <div>{{loc.name}}</div>
                <div class=" text-xs">{{loc.owner.displayName}}</div>
                
              </mat-option>
            }
            <!-- <mat-option [value]="freshLocation">- Create new {{LOCATION_LABEL}} -</mat-option> -->
          </mat-select>
        <!-- }@else{
          <msh-button
            [cta]="'Create new ' + LOCATION_LABEL"
            (click)="onSelectLocationChange()"
            class="w-full my-7 block px-3 py-2 rounded border "
          >
            Select Location
          </msh-button> -->
        }
      }
      
    }
    @if(cta === 'Create' || cta === 'Update'){
      @if(needsGoogleSelector){
        <msh-address-autocomplete
          addressType="physical"
          [defaultSearchQuery]="!!locQuestionsData && locQuestionsData.segments[0]?.googleSearchInput || ''"
          [includedPrimaryTypes]="!!locQuestionsData && locQuestionsData.segments[0]?.googleSearchTypes || []"
          (placeSelected)="locationSelected('physical', $event)"
        ></msh-address-autocomplete>
      }
      @if(this.addressId.physical){
        <div>
          <input
            type="text"
            placeholder="Location Name"
            [(ngModel)]="newLocation.name"
            name="newLocation.name"
            [limiter]="250"
            required
          />
        </div>
      }
      @if(shippingAddress){
        <div class="mb-3">
          <div class="flex justify-between">
            <div>Shipping Address:</div>
            <div class="hover:text-orange-500 cursor-pointer" (click)="shippingAddress = ''"><mat-icon>delete</mat-icon></div>
          </div>
          <div class=" font-thin">{{shippingAddress}}</div>
        </div>
      } @else if(cta === 'Create' && !shippingSameAsPhysical){
        <msh-address-autocomplete
          class="mt-6 block"
          addressType="shipping"
          [defaultIncludedPrimaryTypes]="[]"
          (placeSelected)="locationSelected('shipping', $event)"
        ></msh-address-autocomplete>
      }
      <div class="my-6 capitalize">{{LOCATION_LABEL}} Profile Image:</div>
      <msh-upload-image 
        class=" m-auto block"
        [maxFiles]="1"
        [locationId]="selectedLoc.id"
        [type]="'location'"
        [id]="selectedLoc.id"
        [existingImages]="existingImages"
        (onImageObjectsUpdated)="onImageObjectsUpdated($event)"
      ></msh-upload-image>

      <input
        type="text"
        [placeholder]="CAPITALIZED_LOCATION_LABEL + ' Description (Optional)'"
        [(ngModel)]="newLocation.description"
        name="newLocation.description"
        required
      />
      @if(locQuestionsData && locQuestionsData.locationQuestions
      && locQuestionsData.locationQuestions.length > 0 
      && locQuestionsData.locationQuestions
      ; as questions){
        @for(question of questions; track question; let questionIndex = $index ){
          <div>{{question.questionLabel}}</div>
          @if(newLocation && answers[question.id]
          && question.locationQuestionOptions_on_locationQuestion.length > 0
          && question.locationQuestionOptions_on_locationQuestion; as options){
            <mat-select class="w-full mb-3 px-3 py-2 rounded border border-navy/15" [(ngModel)]="answers[question.id].answerValues"
            (ngModelChange)="checkLocationQuestion(question.isMandatory || false, answers[question.id].answerValues, question.id)">
              @for(opt of options; track opt){
                <mat-option [value]="opt.optionValue">{{opt.optionText}}</mat-option>
              }
            </mat-select>
          }@else if(newLocation && newLocation.locationAnswers_on_location && newLocation.locationAnswers_on_location[questionIndex]){
            <input type="text"
            [class]="(missingMandatoryLocationQuestionIds.includes(question.id) ? ' shadow-[inset_0_0_2px_rgba(255,0,0,1)]' :  '') + ' rounded w-full mb-3 px-3 py-2'"
            [placeholder]="question.displayLabel"
            [(ngModel)]="newLocation.locationAnswers_on_location[questionIndex].answerText"
            (ngModelChange)="checkLocationQuestion(question.isMandatory || false, newLocation.locationAnswers_on_location[questionIndex].answerText || '', question.id)"
            [name]="question.displayLabel || ''"
            required
          />
          }
        }
      }
    }
    @if(cta === ctas.Create) {<div class=" mb-4 text-xs null">These details can be updated at any time.</div>}
    @if(cta){
      <msh-button [disabled]="disabled || (cta === ctas.Create && missingMandatoryLocationQuestionIds.length > 0)" (onClick)="onSubmitClick()" [isLoading]="isLoading" [cta]="cta + ' ' + LOCATION_LABEL "></msh-button>
    }        
    @if(cta === 'Update'){ 
      <div (click)="cancel()" class=" mt-14 mb-2 text-right cursor-pointer text-orange-400 text-sm">< cancel</div> 
      <!-- TODO: uncomment once you figure out the flow @if(this.currentLocation && this.currentLocation.owner){
        <div class=" mt-28">
          <msh-button overrideClass="!bg-red-500" (onClick)="deleteLocationAccount()" [cta]="'Delete '+LOCATION_LABEL+' Account'"></msh-button>
        </div>
      } -->
    }
  }
  `,
  styles: ``
})
export class ManageLocationsFormComponent implements OnInit, OnChanges {
  @Input() segmentId!: number;
  @Input() disabled = false;
  @Input() hideForm = false;
  @Input() locations: LocationPublic[] = [];
  @Input() shippingSameAsPhysical = false;
  @Input() defaultLocationId?: string;
  @Output() onCreateProgress: EventEmitter<LocCreationMode> = new EventEmitter();
  addressSearchText = '';
  addressId: {physical?: string, shipping?: string} = {physical: '', shipping: ''};
  providerAddressId?: string;
  authUser!: any;
  isLoading = false;
  ctas = {Create: "Create", Update: "Update", Edit: "Edit", Switch: "Switch To"}
  cta: string = this.ctas.Edit;
  selectedLoc!: LocationPublic; // [ ] Check to make sure location always has id (when uploading image)
  freshLocation: () => Partial<LocationPublic> = () => ({id: uuidV4().replaceAll("-",""), name: '', description: '', locationAnswers_on_location: []});
  newLocation: Partial<LocationPublic> = {name: '', description: '', locationAnswers_on_location: []};
  locQuestionsData!: GetLocationQuestionsPublicData;
  currentLocation: LocationPublic | null = null;
  existingImages: { image: ImageUploadPublic; sortOrder: number }[] = [];
  shippingAddress = '';
  answers: {[questionId: string]: QuestionAnswerPairsPublic} = {};
  needsGoogleSelector = false;
  missingMandatoryLocationQuestionIds: string[] = [];
  LOCATION_LABEL = LOCATION_LABEL;
  CAPITALIZED_LOCATION_LABEL = LOCATION_LABEL.charAt(0).toUpperCase() + LOCATION_LABEL.slice(1);


  constructor(
    private accountService: AccountService,
    private uploadService: UploadService,
    private authService: AuthService,
    private shippingService: ShippingService,
    private snackBar: MatSnackBar,
    private functions: Functions,
    private store: Store,
    private dialog: MatDialog,
  ){}

  async ngOnInit(): Promise<void> {
    this.authUser = await lastValueFrom(this.store.select(authUserFeature.selectUser).pipe(take(1)))
  }

  async ngOnChanges(changes: SimpleChanges): Promise<void> {
    if(changes['defaultLocationId'] || changes['locations']){
    await this.loadLocationQuestions();
      this.currentLocation = this.locations.find(loc => loc.id === this.defaultLocationId) || null;
      console.log({location: this.selectedLoc, currentLocation: this.currentLocation});
      if(this.locations.length > 0){
        this.onSelectLocationChange();
        this.cta = this.ctas.Edit;
      } else {
        this.setNewLocation();
        this.setNewLocationAnswers();
        this.missingMandatoryLocationQuestionIds.push('_physicalAddress');
        if(!this.shippingSameAsPhysical){
          this.missingMandatoryLocationQuestionIds.push('_shippingAddress');
        }
        this.cta = this.ctas.Create;
        this.needsGoogleSelector = true;
      }
      this.selectedLoc = this.locations.find(loc => loc.id === this.defaultLocationId) || this.freshLocation() as LocationPublic;
    }
  }

  async loadLocationQuestions(){
    const locQuestionResults = await getLocationQuestionsPublic({segmentId: this.segmentId || 0})
    this.locQuestionsData = locQuestionResults.data;
    this.locQuestionsData.locationQuestions.sort(sortByKey("sortOrder"));
  }

  async onSelectLocationChange(){
    console.log({location: this.selectedLoc});
    this.cta = this.newLocation.id ? (this.newLocation.id === this.defaultLocationId ? this.ctas.Edit : this.ctas.Switch) : this.ctas.Create;
    this.setNewLocation();
    this.setNewLocationAnswers();
  }

  setNewLocation(){
    if(!this.selectedLoc) this.selectedLoc = this.freshLocation() as LocationPublic;
    this.newLocation = JSON.parse(JSON.stringify(this.selectedLoc));
    this.answers = this.newLocation.locationAnswers_on_location?.reduce((a, ans: QuestionAnswerPairsPublic)=>{ a[ans?.question?.id || ""]   = ans; return a}, {} as {[questionId:string]: QuestionAnswerPairsPublic}) || {};
    console.log({answers: this.answers})
    this.existingImages = this.newLocation.profileImage ? [{image: {url: this.newLocation.profileImage.url || "", statusId: this.newLocation.profileImage.statusId || "", id: this.newLocation.profileImage.id || ""}, sortOrder: 0}] : [];
    this.needsGoogleSelector = false;
  }

  async retryPaymentProcessorSetup(locationId: string){
    await this.accountService.setupPaymentProcessor(locationId)
  }

  setNewLocationAnswers(){
    const answers = this.newLocation.locationAnswers_on_location || [];
    this.newLocation.locationAnswers_on_location = [];
    this.existingImages = this.newLocation.profileImage ? [{image: {url: this.newLocation.profileImage.url || "", statusId: this.newLocation.profileImage.statusId || "", id: this.newLocation.profileImage.id || ""}, sortOrder: 0}] : [];

    if(this.locQuestionsData && this.locQuestionsData.locationQuestions){
      this.locQuestionsData.locationQuestions.forEach((question) => {
        const answer = answers.find(a=>a && a.question && a.question.id === question.id) 
        if(!answer && question.isMandatory){
          this.missingMandatoryLocationQuestionIds.push(question.id)
        }
        if(!this.newLocation || !this.newLocation.locationAnswers_on_location) return;
        this.newLocation.locationAnswers_on_location.push(answer || {
          question:{ id: question.id, displayOnListing: !!question.displayOnListing, displayLabel: question.displayLabel || "", sortOrder: question.sortOrder || 0},
          answerText: '',
          answerValues: [],
        } );
      })
    }
  }

  async onEditLocation(addressType: AddressType, address?: AddressPublic ){
    if(!address) {
      this.snackBar.open("No address provided", 'Close', {duration: 3000}); 
      return;
    }
    const data: AddressData = { address, addressType };
    const dialogRef = this.dialog.open(AddressDialog, { data });
    const result = await lastValueFrom(dialogRef.afterClosed().pipe(take(1)));
    if(result){
      if(addressType === 'physical'){
        this.newLocation.physicalAddress = result;
      } else if(addressType === 'shipping'){
        this.newLocation.shippingAddress = result;
      }
    }
  }

  onImageObjectsUpdated(imageObjects: {image: ImageUploadPublic; sortOrder: number}[]){
    this.newLocation.profileImage = imageObjects[0]?.image;
  }

  cancel(){
    this.cta = this.ctas.Edit;
  }

  async onSubmitClick(){
    this.isLoading = true;
    switch(this.cta){
      case this.ctas.Edit:
        this.cta = this.ctas.Update;
        this.setNewLocation();
        this.setNewLocationAnswers();
        break;
      case this.ctas.Create:
        let CreateLocation;
        this.onCreateProgress.emit("start");
        this.cta = this.ctas.Edit;
        window.scrollTo(0,0)
        const vars: CreateLocationVariables = {
          id: this.newLocation.id || uuidV4(), 
          segmentId: this.segmentId,
          name: this.newLocation.name || '', 
          description: this.newLocation.description || '', 
          profileImageId: this.newLocation.profileImage?.id || null, 
          physicalAddressId: this.addressId?.physical || null,
          shippingAddressId: this.addressId?.shipping || null,
        }
        log.log({vars})
        try {
          CreateLocation = await createLocation(vars);
        } catch(error){
          log.log({loc: "createLocation", error})
          this.snackBar.open("Error creating "+LOCATION_LABEL+". Please refresh and try again.", 'Close', {duration: 8000})
          throw new Error("Create "+LOCATION_LABEL+" error")
        }
        this.onCreateProgress.emit("creating record");
        console.log({CreateLocation, answers: this.newLocation.locationAnswers_on_location})
        this.answers = this.newLocation.locationAnswers_on_location?.reduce((a, ans)=>{a[ans.question?.id || "-noQuestion-"] = ans; return a;},{} as {[questionId: string]: QuestionAnswerPairsPublic}) || {}
        await this.upsertLocationAnswers(vars.id);
        this.onCreateProgress.emit("attaching address");
        console.log({newLocId: vars.id, addressId: this.addressId})
        await uiErrorCatcher( this.attachAddresses(vars.id), this.snackBar, "Error attaching address");
        
        await this.accountService.setDefaultLocationId(vars.id, this.authUser.id);
        this.onCreateProgress.emit("logging details");
        await this.accountService.loadMyAccountInfo('manage loc form submit Create: '+this.cta);
        this.onCreateProgress.emit("initiating payment processor");
        await this.accountService.setupPaymentProcessor(vars.id)
        this.onCreateProgress.emit("waiting for response");
          // TODO: ADD A WELCOME PAGE WITH INSTRUCTIONS AND GUIDES
        break;
      case this.ctas.Update:
        const updatedLocId = this.selectedLoc?.id || ''
        const updateVars: UpdateLocationVariables = {
          locationId: updatedLocId,
          segmentId: this.segmentId,
          name: this.newLocation.name || '',
          description: this.newLocation.description || '',
          profileImageId: this.newLocation.profileImage?.id || null,
        }
        if(this.currentLocation?.profileImage?.id && (this.newLocation.profileImage?.id !== this.currentLocation.profileImage.id)){
          await this.uploadService.deleteUploadedImages([this.currentLocation.profileImage.id])
        }
        console.log({updateVars})
        try {
          const UpdateLocation = await updateLocation(updateVars);
          console.log({UpdateLocation, answers: this.newLocation.locationAnswers_on_location})
        } catch(err){
          console.error({err})
        }
        const imageIdsThatNeedTransferring = this.newLocation.profileImage && [this.newLocation.profileImage].filter(img => img.statusId === 'initiated' || /tempUploaded/.test(img.url)).map(img => img.id)
        if(imageIdsThatNeedTransferring && imageIdsThatNeedTransferring?.length > 0){
          const vars: TransferNewUploadedImagesVariables = {
            objectId: this.newLocation.id,
            imageIds: imageIdsThatNeedTransferring,
          }
          log.log({vars})
          const callable = httpsCallable<TransferNewUploadedImagesVariables, {success: boolean}>(this.functions, 'transferNewUploadedImages');
          const result: HttpsCallableResult<{success: boolean }> = await callable(vars);
          log.log({imageIdsThatNeedTransferringResult: result})
        }
        await this.upsertLocationAnswers(updatedLocId);
        setTimeout(async ()=>{
          await this.accountService.loadMyAccountInfo('manage loc form submit Update: '+this.cta);
          this.cta = this.ctas.Edit;
        },0)
        break;
      case this.ctas.Switch:
        // TODO ADD loading when: Save default location to firebase user - should cause a chain reaction
        await this.accountService.setDefaultLocationId(this.selectedLoc?.id || '', this.authUser.id);
        this.cta = this.ctas.Edit;
        break;
    }
    this.isLoading = false;
  }

  async upsertLocationAnswers(locationId: string){
    if(this.locQuestionsData && this.locQuestionsData.locationQuestions.length > 0){
      for (let i = 0; i < this.locQuestionsData.locationQuestions.length; i++) {
        const question = this.locQuestionsData.locationQuestions[i];
        const answer = this.answers[question.id];
        console.log({answer: answer, question });
        const upsertAnswerData: UpsertLocationAnswerVariables = {
          locationId,
          questionId: question.id,
          answerText: answer?.answerText,
          answerValues: answer?.answerValues
        } ;
      console.log({answerData: upsertAnswerData})
      const upsertLocationAnswersResults = await uiErrorCatcher(upsertLocationAnswer(upsertAnswerData), this.snackBar, "Error saving "+LOCATION_LABEL+" answers"); 
      console.log({upsertLocationAnswersResults})
      } 
    }
  }

  async locationSelected(type: 'shipping' | 'physical', data: AddressAutocompleteReturn){
    console.log({data});
    // GOOGLE DOESN'T ALLOW CACHING, EVEN OF THE URL
    //const photo = data.photos[0];
    // if(photo){
    // // make image entry
    // // set image as existing
    //   const imageInfo = await this.createImageRecord(photo.googleMapsUri, photo.widthPx, photo.heightPx)
    //   this.newLocation.profileImage = {id: imageInfo.id, url: photo.googleMapsUri};
    //   this.existingImages = [this.newLocation.profileImage as ImageUploadPublic]
    // }

    // make address entry
    // set as this address
    const _user = await lastValueFrom(this.store.select(authUserFeature.selectUser).pipe(take(1)));
    const user: AuthUser = _user as unknown as AuthUser;
    const initiateAddressVars: InitiateAddressVariables = {
      streetNumber: data.streetNumber,
      address: data.route,
      city: data.city,
      state: data.state,
      postcode: data.postalCode,
      googlePlaceId: data.id,
      validationStatus: 'Google Place Created',
    }

    // check if googlePlaceId exists
    const addressAlreadyExistsRef = await uiErrorCatcher(getGooglePlaceIds({ googlePlaceIds: [data.id] }), this.snackBar, "Error validating address");
    const addressAlreadyExists = addressAlreadyExistsRef.data.addresses && addressAlreadyExistsRef.data.addresses.length > 0;
    if(addressAlreadyExists){
      // if you need to make segments only allow for one location, this is where you can stop duplicates
      this.addressId[type] = addressAlreadyExistsRef.data.addresses[0].id;
    } else {
      try {
        const addressRef = await initiateAddress(initiateAddressVars);
        this.addressId[type] = addressRef.data.address_insert.id
      } catch(error){
        log.error(error);
        
      }
    }

    console.log({shippingSameAsPhysical: this.shippingSameAsPhysical, addressId: this.addressId})
    if(type === 'physical'){
      this.missingMandatoryLocationQuestionIds = this.missingMandatoryLocationQuestionIds.filter(id => id !== '_physicalAddress');
      this.newLocation.name = data.city+', '+data.state; // TODO: Make global getAbbr(state) function      
    }
    if(this.shippingSameAsPhysical){
      this.addressId.shipping = this.addressId.physical;
    }
    if(type === 'shipping' || this.shippingSameAsPhysical){
      if(!this.shippingSameAsPhysical){
        this.missingMandatoryLocationQuestionIds = this.missingMandatoryLocationQuestionIds.filter(id => id !== '_shippingAddress');
      }
      this.shippingAddress = data.formattedAddress;
      const name = this.newLocation.name || data.displayName + ", "+  data.city+', '+data.state; // TODO: Make global getAbbr(state) function      
      try {
        this.providerAddressId = await this.shippingService.getShippingProviderAddressId({
          name,
          streetNo: data.streetNumber,
          street1: data.route,
          city: data.city,
          state: data.state,
          zip: data.postalCode,
          country: "US",
          phone: user.mobile || '',
          email: user.email,
        })
        if(!this.providerAddressId){
          this.snackBar.open("Error connecting to shipping provider. Please try again or contact support.", 'Close', {duration: 8000})
          log.error("No provider address id returned from shipping service")
        }
      } catch(error){
        log.error(error);
      }
    }
    console.log({addressId: this.addressId, providerAddressId: this.providerAddressId})
    // TODO SAVE addressId and providerAddressId to use when attaching address to location on submit just in case the browser is reloaded in between picking a location address and saving the location
    // default the name input value
    // hide selector
   // this.needsGoogleSelector = false;
  }

  async attachAddresses(locationId: string, processorUserId?: string) {
    if(!this.addressId || !this.addressId.physical || !this.addressId.shipping) throw new Error(`Error: No address id exists to attach to this ${LOCATION_LABEL}`)
    if(!locationId) throw new Error(`Error: No ${LOCATION_LABEL} id present to attach address to`)
    if(!processorUserId) {
      processorUserId = uuidV4()
    }
    const physicalAndBillingVars: AttachPhysicalAndBillingAddressVariables = { locationId, physicalAddressId: this.addressId.physical, billingAddressId: this.addressId.shipping || this.addressId.physical};
    console.log({physicalAndBillingVars})
    const physicalAndBillingResults = await attachPhysicalAndBillingAddress(physicalAndBillingVars);
    console.log({physicalAndBillingResults})
    const shippingAddressId = this.addressId.shipping || this.addressId.physical;
    const shippingVars: AttachShippingAddressVariables = { locationId, addressId: shippingAddressId, processorAddressId: this.providerAddressId, processorUserId };
    console.log({shippingVars})
    const shippingResults = await attachShippingAddress(shippingVars);
    log.log({physicalAndBillingResults, shippingResults})
  }

  checkLocationQuestion(isMandatory: boolean, value: string | string[], questionId: string){
    if(isMandatory && !value){
      this.missingMandatoryLocationQuestionIds.push(questionId);
    }else{
      this.missingMandatoryLocationQuestionIds = this.missingMandatoryLocationQuestionIds.filter(id => id !== questionId)
    }
  }

  async deleteLocationAccount(){
    const data: ConfirmDeleteDialogData = {
      info: [
        'Are you sure you want to do this?', 
        'You will have +COOL_DOWN_TIME+ until your lose access', // TODO: figure this out
        'to this account.  If you do'
      ],
      action: 'Delete',
      item: 'Location Account',
      class: ''
    }
    const dialog = this.dialog.open(ConfirmDeleteDialogComponent, {data})
    const result = await lastValueFrom(dialog.afterClosed().pipe(take(1)))
    if(result){
      console.log('test')
    }
  }

  async createImageRecord(url: string, width: number, height: number): Promise<{id:string, url:string}>{
    const vars: ImageUploadVariables = {
      url,
      filename: '_google_hosted_',
      contentType: '_google_hosted_',
      sizeInBytes: 0,
      width,
      height,
      orientation: 1,
      key: '_google_hosted_',
    };
    console.log({vars});
    // await this.uploadService.registerUpload({ key: presign.key, metadata: f.uploadedMeta });
    const uploadResult = await imageUpload(vars);
    
    const id = uploadResult.data.image_insert.id
    return {id, url: vars.url};
  }
}
